import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-4">
            实时排行
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            热度榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            根据实时观看数据与讨论热度综合排序
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="rounded-xl bg-background-100 border border-background-200/50 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={item.id}
                href="#media"
                className={`flex items-center gap-4 px-4 md:px-6 py-4 hover:bg-background-50/50 transition-colors cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className="shrink-0 w-8 md:w-9 text-center">
                  {item.rank <= 3 ? (
                    <span className={`inline-flex items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-lg text-sm font-bold ${
                      item.rank === 1 ? 'bg-primary-500 text-foreground-50' :
                      item.rank === 2 ? 'bg-accent-500 text-foreground-50' :
                      'bg-secondary-500 text-foreground-50'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-base font-bold text-foreground-500">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base text-foreground-200 font-medium truncate hover:text-primary-400 transition-colors">
                    {item.title}
                  </p>
                </div>

                <span className={`shrink-0 px-2 py-0.5 text-[11px] font-medium rounded whitespace-nowrap text-foreground-50 ${item.tagColor}`}>
                  {item.tag}
                </span>

                <span className="shrink-0 text-xs md:text-sm text-foreground-400 font-mono whitespace-nowrap w-[72px] md:w-[80px] text-right">
                  {item.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}